<template>
    <div class="p-root root">
        <OFontsController/>
        <OStatisticsController/>
        <OSurveillanceController/>
        <OIntegrationEventsController/>
        <OExceptionsHandler/>
        <router-view />
        <div
            v-if="isRedirected"
            class="root__wrapper"
        >
            <AButton
                v-for="(route, index) in routes"
                :key="index"
                :text="route.name"
                @onClick="redirect(route.path)"
            />
        </div>
    </div>
</template>

<script>
import AButton from '@/components/atoms/a-button/a-button';
import * as Sentry from '@sentry/browser';
import {mapActions} from "vuex";
import OFontsController from "@/components/organisms/o-fonts-controller/o-fonts-controller";
import OExceptionsHandler from "@/components/organisms/o-exceptions-handler/o-exceptions-handler";
import OStatisticsController from "@/components/organisms/o-statistics-controller/o-statistics-controller";
import OSurveillanceController from "@/components/organisms/o-surveillance-controller/o-surveillance-controller";
import OIntegrationEventsController
    from "@/components/organisms/o-integration-events-controller/o-integration-events-controller";

export default {
    name: 'PRoot',
    data() {
        return {
            redirected: false,
            routes: [
                {
                    name: 'Ski Storsenter (offline beta)',
                    path:'/map-72646960/terminal-G72-ZT3Q-Q1MX-3638/start?dataSource=LOCALHOST',
                },
                {
                    name: 'Storo Storsenter',
                    path:'/map-65671528/terminal-JOO-RMJC-ZI9Z-E8H2/start',
                },
                {
                    name: 'Sartor Storsenter',
                    path:'/map-36113132/terminal-429-AOVH-JAQE-IZL0/start'
                },{
                    name: 'Asane Storsenter',
                    path:'map-69227112/terminal-646-ZJQX-PFNF-G142/start'
                },
                {
                    name: 'Coming soon...',
                    path:'/'
                },
            ]
        }
    },
    components: {
        OFontsController,
        OIntegrationEventsController,
        OSurveillanceController,
        OExceptionsHandler,
        OStatisticsController,
        AButton
    },
    computed: {
        isRedirected() {
            return this.$route.path === '/';
        }
    },
    methods: {
        ...mapActions([
            "registerAWSIdentity",
            "generateSessionId",
        ]),
        redirect(val) {
            this.$router.push(
                {
                    path: val
                }
            );
        }
    },
    created() {
        if(!document.location.href.includes('localhost')){
            Sentry.setTag("app-type", this.$route.name && this.$route.name.split('.')[0]);
        }

        this.registerAWSIdentity();
        this.generateSessionId();

        if(this.$route.query.ui === '0'){
            const sheet = document.createElement('style');
            sheet.innerHTML = ".ui {display: none !important;}";
            document.body.appendChild(sheet);
        }
    }
}
</script>

<style lang="scss">
@import "p-root";
</style>
